/** import custom dependency [start] */
import globalConfig from '../config/config';
import { setCookie, getCookie } from './cookies';
/** import custom dependency [end] */

/**
 * to set the access token
 * @param token JWT token
 */
const setAccessToken = (token: string): void => {
    /** access token config */
    const accessTokenConfig = globalConfig.getConfig?.token.access;
    setCookie(accessTokenConfig?.name || 'access_token', token, accessTokenConfig?.cookieExpiryTimeInMin || 58);
};

/**
 * to get the access token
 * @returns string | null
 */
const getAccessToken = (): string | null => {
    /** access token config */
    const accessTokenConfig = globalConfig.getConfig?.token.access;
    let value: string | null = '';
    if (globalConfig.getConfig?.authEnabled) {
        value = getCookie(accessTokenConfig?.name || 'access_token');
    } else {
        value = accessTokenConfig?.tempValue ? accessTokenConfig?.tempValue : null;
    }
    return value;
};

/**
 * to get the refresh token
 * @returns string | null
 */
const getRefreshToken = (): string | null => {
    /** access token config */
    const refreshTokenConfig = globalConfig.getConfig?.token.refresh;
    let value: string | null = '';
    if (globalConfig.getConfig?.authEnabled) {
        value = getCookie(refreshTokenConfig?.name || 'refresh_token');
    } else {
        value = refreshTokenConfig?.tempValue ? refreshTokenConfig?.tempValue : null;
    }
    return value;
};

/**
 * to remove the access token
 */
const removeAccessToken = (): void => {
    /** access token config */
    const accessTokenConfig = globalConfig.getConfig?.token.access;
    setCookie(accessTokenConfig?.name || 'access_token', '', undefined, true);
};

/**
 * to remove the refresh token
 */
const removeRefreshToken = (): void => {
    /** access token config */
    const refreshTokenConfig = globalConfig.getConfig?.token.refresh;
    setCookie(refreshTokenConfig?.name || 'refresh_token', '', undefined, true);
};

export { setAccessToken, getAccessToken, removeAccessToken, getRefreshToken, removeRefreshToken };
